import Vue from 'vue'
import Router from 'vue-router'


const MemberLine   = () => import('@/components/shop/memberEntryLINE');
const MemberFB     = () => import('@/components/shop/memberEntryFB');
const HistoryPage  = () => import('@/components/shop/page/history');
const PremHistory  = () => import('@/components/shop/premium/history');
const Checkout     = () => import('@/components/shop/checkout');
const Member       = () => import('@/components/shop/memberEntry');
const Success      = () => import('@/components/success');
const Shop         = () => import('@/components/shop/page/shop');


Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Success,
    },
    {
      path: '/premium',
      name: 'memberPremium',
      component: Member,
    },
    {
      path: '/line',
      name: 'memberLine',
      component: MemberLine,
    },
    {
      path: '/fb',
      name: 'memberFB',
      component: MemberFB,
    },
    {
      path: '/checkout/:Auth_u',
      name: 'checkout',
      component: Checkout
    },
    {
      path: '/shop/:service/:Auth_u',
      name: 'shop',
      component: Shop
    },
    {
      path: '/history/:service/:Auth_u',
      name: 'history',
      component: HistoryPage
    },
    {
      path: '/premhistory/:Auth_u',
      name: 'premhistory',
      component: PremHistory
    }
  ]
})

export default router;